export default __webpack_public_path__ + "static/media/GR6 2B-4D-2EC.f82b8c43.jpg";